module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfBAMAAADtgAsKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTBlYhRBQgBhYgxpYhRpYhBpYhBhYhxhYhRVahRpZhhhZhBlYhRlYhBpZhV8A8MwAAAAOdFJOUwCCEEDxodAgYDBQcOC3SC0xfQAAANxJREFUKM9jYCAWVCmgCeRtQBN4J4DEYYKqYIcJpDQwMCgD6TioKia/5wxMxhMYGN8FQFX0Pec49+5dJOMzmE3sE+69A4IGI7iprO8cjZe+e4Wwxg6keMobhMA9JyDB8a4BzVXnLkB4Zc+U3xmA1R1oeQqi172zeDcBxJB7EPcERGtLM0NUxDkUSkE0cYKdyOR3AWHLC7BjDOACJe8WAHW8RbiD089RUPRdElKI2AG98gQ5ENmAAq+RA5DxHYPdS1SBgn0PkAWY3130QxFgAoaYAEos1L47qMBALgAAbFdNEUyCuVwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/Idea-Bulb.png
// module id = 1165
// module chunks = 0